import { Box, List, ListItem, Typography } from '@mui/material'
import { ArrowNarrowRightIcon } from '@untitled-theme/icons-react'
import { useNavigate, useParams } from 'react-router-dom'

import Button from '@/shared/components/Button'
import HamburgerMenu from '@/shared/components/HamburgerMenu'

const StartPage = () => {
  const navigate = useNavigate()
  const { buildingUuid } = useParams<{ buildingUuid: string }>()

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        width: '100vw',
        backgroundColor: '#ffffff',
        padding: 4,
      }}
    >
      <HamburgerMenu
        sx={{
          position: 'fixed',
          top: 32,
          left: 32,
        }}
      />

      <Box sx={{ maxWidth: '556px', width: '100%' }}>
        <Typography
          component="h1"
          sx={{
            fontWeight: 600,
            fontSize: '45px',
            lineHeight: '62px',
            marginBottom: '8px',
            whiteSpace: 'pre-line',
          }}
        >
          Energieberatung{'\n'}
          <Box component="span" sx={{ color: '#4caf50' }}>
            Übersicht
          </Box>
        </Typography>

        <Typography
          sx={{
            fontWeight: 500,
            fontSize: '12px',
            lineHeight: '18px',
            marginBottom: '48px',
            color: '#74777F',
          }}
        >
          Unsere Energieberatung bietet Ihnen einen Überblick über alle Schritte zur Optimierung
          Ihres Gebäudes:
        </Typography>

        <Typography
          sx={{
            color: '#474464',
            fontWeight: 500,
            fontSize: '12px',
            lineHeight: '18px',
            marginBottom: '32px',
          }}
        >
          Inhalt:
        </Typography>

        <List sx={{ padding: 0, display: 'flex', flexDirection: 'column', gap: '48px' }}>
          {[
            {
              title: 'Ausblick Energiekosten',
              description:
                'Ein Ausblick auf die in den kommenden Jahren zu erwartenden steigenden Kosten sowie mögliche Förderungen.',
              path: 'energy-cost',
            },
            {
              title: 'Aktuelle Bewertung',
              description:
                'Detaillierte Bewertung des energetischen Zustands Ihrer Immobilie sowie des Einsparpotenzials.',
              path: 'current-rating',
            },
            {
              title: 'Maßnahmen im Überblick',
              description:
                'Maßnahmen einsehen und vergleichen – sortiert nach Einsparung, Kosten und Eignung für Ihr Zuhause.',
              path: 'measures-overview',
            },
          ].map((item, index) => (
            <ListItem
              key={index}
              onClick={() => navigate(`/${buildingUuid}/${item.path}`)}
              sx={{
                padding: 2,
                margin: -2,
                display: 'flex',
                alignItems: 'flex-start',
                gap: '40px',
                cursor: 'pointer',
                '&:hover': {
                  borderRadius: 2,
                  backgroundColor: '#F5F5F5',
                },
              }}
            >
              <Typography
                sx={{
                  color: '#5BC06B',
                  fontWeight: 600,
                  fontSize: '28px',
                  lineHeight: '42px',
                  flexShrink: 0,
                }}
              >
                {String(index + 1).padStart(2, '0')}
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: '24px',
                    lineHeight: '36px',
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  sx={{
                    color: '#74777F',
                    fontWeight: 500,
                    fontSize: '12px',
                    lineHeight: '18px',
                  }}
                >
                  {item.description}
                </Typography>
              </Box>
            </ListItem>
          ))}
        </List>
      </Box>

      <Button
        endIcon={<ArrowNarrowRightIcon />}
        onClick={() => navigate(`/${buildingUuid}/energy-cost`)}
        sx={{
          position: 'fixed',
          bottom: 32,
          right: 32,
        }}
      >
        Weiter
      </Button>
    </Box>
  )
}

export default StartPage
